import { SkipBack, SkipForward } from "@/icons";

export const SkipButton = ({
  direction,
  handleClick,
}: {
  direction: "back" | "forward";
  handleClick: () => void;
}) => (
  <button onClick={handleClick} className="h-6 w-6">
    {direction === "back" ? <SkipBack /> : <SkipForward />}
  </button>
);
